export default {
    'please-select-a-filter': 'رجاءً قم باختيار أحد الفلاتر',
    customers: 'الزبائن',
    'external-entities': 'الجهات الخارجية',
    staff: 'طاقم العمل',
    input: 'إدخال',
    output: 'إخراج',
    'total-sales': 'مجموع المبيعات',
    "hide-show-column": "إخفاء / إظهار الأعمدة و ترتيبها",
    "apply": "تطبيق",
}